import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SignOut, Sparkle, CoatHanger, ChatCircleDots, Calendar, House, BookmarkSimple } from "@phosphor-icons/react";

const links = [
  { to: "/app", label: "Dashboard", icon: House, testid: "nav-dashboard" },
  { to: "/wardrobe", label: "Wardrobe", icon: CoatHanger, testid: "nav-wardrobe" },
  { to: "/chat", label: "Chat", icon: ChatCircleDots, testid: "nav-chat" },
  { to: "/occasion", label: "Occasion", icon: Calendar, testid: "nav-occasion" },
  { to: "/lookbook", label: "Look Book", icon: BookmarkSimple, testid: "nav-lookbook" },
];

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => { await logout(); navigate("/"); };

  return (
    <div className="min-h-[100dvh] bg-cream-50">
      <header className="sticky top-0 z-40 glass-header border-b border-cream-200">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 flex items-center justify-between h-16">
          <Link to="/app" className="flex items-center gap-2" data-testid="app-logo">
            <Sparkle weight="fill" size={22} className="text-charcoal-700" />
            <span className="font-serif text-2xl tracking-tight text-charcoal-800">Ava</span>
            <span className="hidden sm:inline text-[0.65rem] tracking-[0.3em] uppercase text-charcoal-500 ml-2">Personal Stylist</span>
          </Link>
          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-4 py-2 rounded-full text-sm transition-all ${
                    isActive ? "bg-charcoal-700 text-white" : "text-charcoal-700 hover:bg-cream-100"
                  }`
                }
              >
                <l.icon size={16} />
                {l.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            {user && (
              <span className="hidden sm:inline text-xs tracking-wider uppercase text-charcoal-500" data-testid="user-greeting">
                Hi, {user.name?.split(" ")[0] || "You"}
              </span>
            )}
            <button
              onClick={handleLogout}
              className="rounded-full p-2 border border-cream-200 text-charcoal-700 hover:bg-cream-100 transition-all"
              data-testid="logout-button"
              aria-label="Log out"
            >
              <SignOut size={16} />
            </button>
          </div>
        </div>
        {/* mobile nav */}
        <nav className="md:hidden flex items-center gap-1 px-4 pb-3 overflow-x-auto no-scrollbar">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs whitespace-nowrap ${
                  isActive ? "bg-charcoal-700 text-white" : "bg-cream-100 text-charcoal-700"
                }`
              }
            >
              <l.icon size={14} />
              {l.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-7xl mx-auto px-6 sm:px-10 py-10">{children}</main>
    </div>
  );
}
